import { render, staticRenderFns } from "./IconIosMenu.vue?vue&type=template&id=43cd0782&scoped=true"
import script from "./IconIosMenu.vue?vue&type=script&lang=js"
export * from "./IconIosMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43cd0782",
  null
  
)

export default component.exports